import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://ali-india.ru';
const DEFAULT_IMAGE = 'https://images.pexels.com/photos/16497359/pexels-photo-16497359.jpeg?auto=compress&w=1200';

const SITE_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'TravelAgency',
  name: 'Ali India Tours',
  url: SITE_URL,
  image: 'https://images.pexels.com/photos/5163881/pexels-photo-5163881.jpeg',
  description: 'Авторские групповые туры по Индии с русскоговорящим гидом Али.',
  priceRange: '$390 – $1290',
  areaServed: ['Индия', 'Дели', 'Агра', 'Джайпур', 'Варанаси', 'Ришикеш', 'Кхаджурахо'],
  sameAs: [
    'https://www.instagram.com/privateindiaguidedtourss',
    'https://vk.ru/privateindiaguideali',
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+91-8958-956-564',
    contactType: 'reservations',
    availableLanguage: ['Russian', 'English', 'Hindi'],
  },
  founder: { '@type': 'Person', name: 'Ali' },
};

export default function SiteSEO({
  title = 'Али — Авторские туры в Индию с русскоговорящим гидом | Дивали, Холи, Новый год, Золотой Треугольник',
  description = 'Многодневные групповые туры по Индии в сопровождении русскоговорящего гида Али. Дивали, Холи, Новый год, Золотой треугольник Дели–Агра–Джайпур, Варанаси, Кхаджурахо. Бронирование в WhatsApp и Telegram.',
  path = '/',
  image = DEFAULT_IMAGE,
  keywords = 'туры в Индию, русский гид в Индии, Али гид, Дивали тур, Холи тур, Новый год в Индии, Золотой треугольник, Дели Агра Джайпур, Варанаси, туры на Холи, авторские туры Индия, групповые туры Индия',
}) {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Ali India Tours" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="ru_RU" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <script type="application/ld+json">{JSON.stringify(SITE_JSONLD)}</script>
    </Helmet>
  );
}
